import { FEED_CARD_COMPANY_FRAGMENT } from '@/components/FeedCard/FeedCardMyFairValue/feedCardCompanyFragment';
import type { ResolvedQueryData } from '@/utilities/genericTypes';
import { gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';

const QUERY = gql(
  `
  query GetUserNarrativesForCompanies($companyIds: [String!]!) {
    Companies(ids: $companyIds, limit: 100) {
      ...FeedCardCompanyFields
    }
  }
`,
  [FEED_CARD_COMPANY_FRAGMENT]
);

export const useNarrativesForCompanies = makeGqlQuery(QUERY, {
  tags: ['narrative'],
});
export type FeedEntityCompanyExtra = ResolvedQueryData<
  typeof useNarrativesForCompanies
>['Companies'][number];
